/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Clients_Summary_HintInputs */

const en_users_form_clients_summary_hint = /** @type {(inputs: Users_Form_Clients_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected clients define which client records this user is associated with.`)
};

const pt_br2_users_form_clients_summary_hint = /** @type {(inputs: Users_Form_Clients_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os clientes selecionados definem quais cadastros de cliente ficam associados a este usuário.`)
};

/**
* | output |
* | --- |
* | "Selected clients define which client records this user is associated with." |
*
* @param {Users_Form_Clients_Summary_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_summary_hint = /** @type {((inputs?: Users_Form_Clients_Summary_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_Summary_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_summary_hint(inputs)
	return pt_br2_users_form_clients_summary_hint(inputs)
});